/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-08 14:18:50
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2020-12-03 16:29:51
 */
import CryptoJS from 'crypto-js'
import qs from 'qs'
import { getLaestVserionInfo } from '@/api'
const ua = navigator.userAgent
/**
 * 是否安卓设备
 */
export const isAndroid = /android/i.test(ua)
/**
 * 是否iOS设备
 */
export const isIOS = /iphone|ipad|ipod/i.test(ua)
export function dateFormat(fmt: string, date: Date) {
  const o: any = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

/**
 * - uyghur 维语
 * - en 英文
 * - zh_CN 中文
 */
export function getAppLanguage() {
  const ua = navigator.userAgent.toLocaleLowerCase()
  if (ua.includes('language/uyghur')) {
    return 'uyghur'
  } else if (ua.includes('language/en')) {
    return 'en'
  } else {
    return 'zh_CN'
  }
  //return 'uyghur'
}

export function useDebug() {
  if (
    window.location.href.includes('debug=true') ||
    window.navigator.userAgent.includes('debug') ||
    window.KIGO_DEBUG
  ) {
    window.KIGO_DEBUG = true
  }

  if (window.location.origin.includes('test')) {
    import(/* webpackChunkName: "vconsole" */ 'vconsole').then(value => {
      const vconsole = value.default
      new vconsole()
    })
  }

  return window.KIGO_DEBUG || false
}

export function aesEncrypt(data: any) {
  const SECRET_KEY = CryptoJS.enc.Utf8.parse('gtD@s6Fh7pNU0WWP')
  const SECRET_IV = CryptoJS.enc.Utf8.parse('abcdefghijklmnop')

  const curData = typeof data == 'string' ? qs.parse(data) : Object.assign(data)
  curData.time = new Date().getTime()

  const dataHex = CryptoJS.enc.Utf8.parse(JSON.stringify(curData))

  const res = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return res
}

export type Platform =
  | 'kigo'
  | 'kixmix'
  | 'weixin'
  | 'qq'
  | 'taktak'
  | 'chekchek'
  | undefined
export function getPlatform(): Platform {
  const ua = navigator.userAgent
  if (/kigo/i.test(ua)) {
    return 'kigo'
  } else if (/kixmix/i.test(ua)) {
    return 'kixmix'
  } else if (/microMessenger/i.test(ua)) {
    return 'weixin'
  } else if (/qq\//i.test(ua)) {
    return 'qq'
  } else if (/taktak/i.test(ua)) {
    return 'taktak'
  } else if (/chekchek/i.test(ua)) {
    return 'chekchek'
  } else {
    // return 'kixmix'
  }
}

export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function getDeviceId() {
  let deviceId = localStorage.getItem('deviceId')
  if (!deviceId) {
    deviceId = guid()
    localStorage.setItem('deviceId', deviceId)
  }
  return deviceId
}

/**
 * 获取ur参数
 * @param variable
 * @returns
 */
export function getQueryVariable(variable: string) {
  const search =
    window.location.search.substr(1) || window.location.hash.split('?')[1] || ''
  const reg = new RegExp('(^|&)' + variable + '=([^&]*)(&|$)')
  const r = search.match(reg)
  if (r != null) return unescape(r[2])
  return null
}
/***
 * 他Zu安
 */
export function unitFormat(num: number, limit = 100000) {
  if (num < limit) {
    return Number(Math.floor(num).toFixed(1))
  }

  return (Math.floor((num / 10000) * 10) / 10).toFixed(1) + 'w'
}

/**
 * - horizontal 横屏
 * - half 半屏
 * - vertical 竖屏
 */
export function getScreen() {
  const ua = navigator.userAgent.toLocaleLowerCase()
  if (ua.includes('horizontal')) {
    return 'horizontal'
  } else if (ua.includes('half')) {
    return 'half'
  } else {
    return 'vertical'
  }
}

export function openScheme(schemeUrl: string, timeout = 2500) {
  const startTime = new Date().getTime()
  window.location.href = schemeUrl
  return new Promise<boolean>((resolve, reject) => {
    const timer = setTimeout(() => {
      const endTime = new Date().getTime()
      if (endTime - startTime > timeout + 50) {
        resolve(true)
      }
      if (document.hidden) {
        resolve(true)
      } else {
        reject(false)
      }
    }, timeout)
    function visibilitychange() {
      clearTimeout(timer)
      resolve(true)
    }
    document.addEventListener('visibilitychange', visibilitychange)
  })
}
export async function toAppMarketEnjoy(channel?: string) {
  if (isAndroid) {
    const { data } = await getLaestVserionInfo({ channel })
    window.location.href = data.apkUrl
  } else if (isIOS) {
    openScheme('https://itunes.apple.com/app/id6449921184').catch(() => {
      throw new Error('ToAppMarket Maybe Fail')
    })
  }
}
